/* eslint-disable */
import React, {PropTypes} from 'react';
import Select from 'react-select';
import $ from 'jquery';

class SelectUF extends React.Component {

    constructor(props, context) {
        super(props, context);
        
        this.state = {
          value: 0,
          limparTela: true
        };
       this.getUFSelecionada = this.getUFSelecionada.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        
        if(this.props.limparSelecao && this.state.limparTela){
            this.setState({value: '0', limparTela: false}); 
        }
        
        if(this.props.selecinarId !== nextProps.selecinarId){
            
                this.setState({value: nextProps.selecinarId}); 
        }
 
    }
    componentDidMount() {
        if(!$.isEmptyObject(this.props.selecinarId)){
           this.setState({value: this.props.selecinarId});
        }
     }
    
    getUFSelecionada(val){
        //console.log('getSituacoesSelecionadas', val);
        
        this.setState({ value: val});
        //console.log('Estrutura selecionada ', this.props.areaTratamento.dado[i]);
        this.props.filterme(val);
    }

 
    render() {
       // //console.log('value', this.state.value)
       
        var lis =  this.props.uf.dado.map(p => ( 
                { value: p.mIdUF.toString(), label: p.mNome }
        ));

        return ( 
            <Select multi={this.props.multi} simpleValue  placeholder="UF" options={lis} value={this.state.value} onChange={this.getUFSelecionada} clearable={false} disabled={this.props.disabled} />
            )
    }
}

SelectUF.protoType = {
    filterme: React.PropTypes.func.isRequired,
    uf: React.PropTypes.object.isRequired
}


export default SelectUF;



/** WEBPACK FOOTER **
 ** ./src/components/common/SelectUF.js
 **/